import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export default {
  InstantOfferStep: lazyLoad({
    loader: () =>
      import(
        /* webpackChunkName: "instant-offer-step" */ 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/instant-offer-step/instant-offer-step'
      ),
    componentName: 'InstantOfferStep',
  }),
};
